import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { bonusHomeBanner as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    getClientName: () => null,
    dateFormat: 'MM/DD/YYYY',
    shouldShowRollingBonuses: false,
    carousel: {
      hasCounter: true,
      hasDots: false,
      loop: true,
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
